module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-14-402250e09fab4af7aed269654c60da9a.jpg";